import { render, staticRenderFns } from "./ButtonLoad.vue?vue&type=template&id=56c78ae1"
import script from "./ButtonLoad.vue?vue&type=script&lang=js"
export * from "./ButtonLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports